export default "/images/vendor/@coreui/icons/svg/flag/cif-py.svg?a45d3b76df1ef3ec1596936edd564948";